import ws from '../utils/ws';

/* Actions */

export const findCellGroups = () => dispatch =>
  dispatch({
    type: FIND_CELL_GROUPS,
    payload: ws.get('/cell_groups/')
  });

export const saveCellGroup = cellGroup => dispatch =>
  dispatch({
    type: SAVE_CELL_GROUP,
    payload: ws.post('/cell_groups/', cellGroup)
  });

export const deleteCellGroup = cellGroupId => dispatch =>
  dispatch({
    type: DELETE_CELL_GROUP,
    payload: ws.post(`/cell_groups/${cellGroupId}/delete`)
  });

/* Constants */

export const FIND_CELL_GROUPS = 'FIND_CELL_GROUPS';
export const FIND_CELL_GROUPS_PENDING = 'FIND_CELL_GROUPS_PENDING';
export const FIND_CELL_GROUPS_FULFILLED = 'FIND_CELL_GROUPS_FULFILLED';

export const SAVE_CELL_GROUP = 'SAVE_CELL_GROUP';
export const SAVE_CELL_GROUP_FULFILLED = 'SAVE_CELL_GROUP_FULFILLED';

export const DELETE_CELL_GROUP = 'DELETE_CELL_GROUP';
export const DELETE_CELL_GROUP_FULFILLED = 'DELETE_CELL_GROUP_FULFILLED';
